import React from 'react';

import createTrack from 'services/actions/tracker_actions';
import { CONLICITASEG_TOOL_LINK } from 'services/conlicitaseg_tool';
import LogoConlicitasegSimbolo from 'assets/images/header/logo-conlicitaseg-simbolo.svg';
import LogoConlicitasegTexto from 'assets/images/header/logo-conlicitaseg-texto.svg';

import { CardLink } from './styles';

interface FeaturedConlicitasegCardProps {
  toolName: string;
}

/** Destaque do ConlicitaSeg no painel do usuário exclusivo (Figma Dashboard-INATIVO 19108:7042). */
const FeaturedConlicitasegCard = ({ toolName }: FeaturedConlicitasegCardProps) => (
  <CardLink
    to={CONLICITASEG_TOOL_LINK}
    aria-label="ConlicitaSeg — Ativo"
    onClick={() => createTrack(`Novo Dashboard - Clicou na ferramenta ${toolName}`)}
  >
    <span className="badge-ativo" aria-hidden="true">
      Ativo
    </span>
    <span className="logo">
      <img src={LogoConlicitasegSimbolo} alt="" width="44" height="44" />
      <img className="logo-texto" src={LogoConlicitasegTexto} alt="" width="147" height="26" />
    </span>
  </CardLink>
);

export default FeaturedConlicitasegCard;
